export default __webpack_public_path__ + "static/media/GR00053-owl_25.ac4dcfec.svg";